import React, {
  useState,
} from 'react';
import styles from './ticketExpand.module.scss'
import cn from 'classnames';
import ExpoTime from './expoTime';
import StationCard from './stationCard';
import { LABEL } from '../../veriables';
import checkBoxIcon from '@assets/images/KDSICONS/checkBox.svg';
import LessThanIcon from '@assets/images/KDSICONS/LessThanIcon.svg';
import greaterIcon from '@assets/images/KDSICONS/greaterIcon.svg'
import moment from 'moment'
import Tooltip from '../KdsExpoStationScreens/ToolTip';

const TicketExpandModal = (props) => {

  const { ticketExpandData, handleTicketExpandView,
    searchOverlay,
    bumpApiCall,
    prepStartAll,
    convertUTCDateToLocalDate,
    themeProperties,
    bumpApiSelected,
    getTileHeight,
    getPrepCompletedTime,
    kdsSettings,
    duplicateDeviceIds,
  } = props;
  // console.log(ticketExpandData)
  const [currentHistoryPage, setCurrentHistoryPage] = useState(1);
  const [orderModeData, setOrderModeData] = useState({});
  const [selectedObjects, setSelectedObjects] = useState({});

  let totalHistoryPage = 1;
  const bumpSelected = (check, checkPrepId) => {

    let items = [];
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      items.push({ entityId: element.entityId, isModifier: element.isModifier })
    }
    bumpApiSelected(check, 'buildSelectedBump', items)
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [checkPrepId]: prevState[checkPrepId].filter(obj => obj.entityId !== element.entityId) // remove the object from the array with the corresponding id
        };
      });
    }

    // selectedObjects[checkPrepId].forEach((element, index) = {
    //   items.push({ entityId: element.entityId, isModifier: element.isModifier})
    // })
  }

  const handleBumpItemClick = () => {
    handleTicketExpandView();
    selectedObjects?.hasOwnProperty(ticketExpandData[0]?.checkPrep?.id + '') &&
      selectedObjects[ticketExpandData[0]?.checkPrep?.id].length > 0 ?
      bumpSelected(ticketExpandData, ticketExpandData[0]?.checkPrep?.id + '') : bumpApiCall(ticketExpandData, 'build')
  }


  const getSortData = data => {
    data.sort((a, b) => a.seatNumber - b.seatNumber);

    const obj = {};

    data.forEach(item => {
      let { seatId } = item;

      if (!kdsSettings?.groupBySeat) {
        seatId = 1234;
      }

      if (!obj[seatId]) {
        obj[seatId] = [];
      }

      obj[seatId].push(item);
    });

    for (let key in obj) {
      let allDayItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.buildStartDate ? val.buildStartDate : val.plannedBuildStartDate).local();
        const currentTime = moment();
        return val.buildStatus != 8 && currentTime > momentTime
      });

      allDayItems = allDayItems.sort((a, b) => {
        const timeA = new Date(a.buildStartDate ? a.buildStartDate : a.plannedBuildStartDate).getTime();
        const timeB = new Date(b.buildStartDate ? b.buildStartDate : b.plannedBuildStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let scheduledItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.buildStartDate ? val.buildStartDate : val.plannedBuildStartDate).local();
        const currentTime = moment();
        return val.buildStatus != 8 && currentTime < momentTime
      });

      scheduledItems = scheduledItems.sort((a, b) => {
        const timeA = new Date(a.buildStartDate ? a.buildStartDate : a.plannedBuildStartDate).getTime();
        const timeB = new Date(b.buildStartDate ? b.buildStartDate : b.plannedBuildStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let completedItems = obj[key].filter(val => val.buildStatus == 8)?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      obj[key] = [...allDayItems, ...scheduledItems, ...completedItems];

    }

    const flattenedArr = [].concat(...Object.values(obj))

    return flattenedArr;
  };

  const renderGroups = () => {
    const groups = [];
    let gpv = 0;
    let getGroupSize = (item) => {
      let a = 0;
      let modifiers = (item) => {
        if (item.length > 0) {
          item.forEach(item => {
            a++;
            if (item.modifiers.length > 0) {
              a++;
              modifiers(item.modifiers)
            }
          })
        }
      }
      let count = 0;
      for (let i = gpv; i <= item?.length; i++, count++) {
        if (item[i]?.modifiers.length > 0) {
          a++;
          modifiers(item[i].modifiers)
          if (a > 15) {
            if (count >= 9) {
              return 9
            }
            return count + 1;
          }
        }
        a++
      }
      return 9;
    }

    let ticketExpandSortData = getSortData(ticketExpandData);

    for (let i = 0; i <= ticketExpandSortData.length; i += gpv) {

      gpv = getGroupSize(ticketExpandSortData);
      const groupItems = ticketExpandSortData.slice(i, i + gpv);

      groups.push(
        <div className='col-4 px-0'>
          <StationCard
            check={groupItems}
            searchOverlay={searchOverlay}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            themeProperties={themeProperties}
            selectedObjects={selectedObjects}
            setSelectedObjects={setSelectedObjects}
            bumpApiSelected={bumpApiSelected}
            getTileHeight={getTileHeight}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            orderModeData={orderModeData}
            setOrderModeData={setOrderModeData}
          />
        </div>
      );
    }
    let tiles = groups.length >= 4 ? 6 : 3
    for (let i = groups.length; i < tiles; i++) {
      groups.push(
        <div className='col-4 px-0 h-100'>
          <StationCard
            check={[]}
            searchOverlay={searchOverlay}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            themeProperties={themeProperties}
            selectedObjects={selectedObjects}
            setSelectedObjects={setSelectedObjects}
            bumpApiSelected={bumpApiSelected}
            getTileHeight={getTileHeight}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            orderModeData={orderModeData}
            setOrderModeData={setOrderModeData}
          />
        </div>
      );
    }


    const totalHistoryItemsPerPage = 3;
    const startIndex = (currentHistoryPage - 1) * totalHistoryItemsPerPage;
    const endIndex = startIndex + totalHistoryItemsPerPage;
    if (groups.length > 4) {
      totalHistoryPage = 2
    }

    return groups.slice(startIndex, endIndex);
  };

  const getMinStartTime = (item) => {
    const buildStartDate = item[0]?.buildStartDate ? item[0]?.buildStartDate : item[0]?.plannedBuildStartDate;
    let minDate = buildStartDate;

    item?.forEach((el) => {
      let tempStartDate = el.buildStartDate ? el.buildStartDate : el.plannedBuildStartDate;

      if (el?.modifiers?.length > 0) {
        el?.modifiers?.forEach((modEl) => {
          minDate = getMinModifierDate(modEl, minDate);
        })
      }
      else {
        if (moment(minDate)?.isSameOrAfter(moment(tempStartDate))) {
          minDate = tempStartDate;
        }
      }

    })
    return minDate;
  }

  const getMinModifierDate = (item, minDate) => {
    let newMinDate = minDate;
    // console.log("item", item)
    if (item?.modifiers?.length > 0) {
      getMinModifierDate(item.modifiers[0], newMinDate);
    }
    else {
      if (item.buildStartDate || item.plannedBuildStartDate) {
        let tempModStartDate = item.buildStartDate ? item.buildStartDate : item.plannedBuildStartDate;

        if (moment(newMinDate)?.isSameOrAfter(moment(tempModStartDate))) {
          newMinDate = tempModStartDate;
        }

      }
    }
    return newMinDate
  }

  return (
    <div className={styles.container}>
      {/* header */}
      <div className={cn('d-flex fs-14 justify-content-between align-items-center p-1 text-uppercase', styles.header)} style={{ background: ticketExpandData[0]?.warningColor }}>

        <div>#{ticketExpandData[0]?.checkPrep?.checkHeader?.number}</div>
        <div>
          {ticketExpandData[0]?.checkPrep?.checkHeader?.name?.length > 4 ?
            <Tooltip innerWidth={innerWidth} text={ticketExpandData[0]?.checkPrep?.checkHeader?.name}>
              {ticketExpandData[0]?.checkPrep?.checkHeader?.tab === true ?
                ticketExpandData[0]?.checkPrep?.checkHeader?.name?.length < 4 ?
                  ticketExpandData[0]?.checkPrep?.checkHeader?.name : <span> {ticketExpandData[0]?.checkPrep?.checkHeader?.name?.substring(0, 4)}..</span> :
                ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber?.length < 4 ?
                  ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber :
                  <span> {ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber?.substring(0, 4)}..</span>}</Tooltip> :
            <> {ticketExpandData[0]?.checkPrep?.checkHeader?.tab === true ?
              ticketExpandData[0]?.checkPrep?.checkHeader?.name?.length < 4 ? ticketExpandData[0]?.checkPrep?.checkHeader?.name :
                <span> {ticketExpandData[0]?.checkPrep?.checkHeader?.name?.substring(0, 4)}</span> :
              ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber?.length < 4 ?
                ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber :
                <span> {ticketExpandData[0]?.checkPrep?.checkHeader?.stationNumber?.substring(0, 4)}..</span>}
            </>}
        </div>
        {kdsSettings?.displayOrderType && <div>{ticketExpandData[0]?.checkPrep?.checkHeader?.orderTypeName}</div>}
        {kdsSettings?.displayRevenueCenter && <div>{ticketExpandData[0]?.checkPrep?.checkHeader?.revenueCenterName}</div>}
        <div>{ticketExpandData[0]?.checkPrep?.checkHeader?.employeeFirstName}&nbsp;{ticketExpandData[0]?.checkPrep?.checkHeader?.employeeLastName}</div>
        <div>
          <ExpoTime date={getMinStartTime(ticketExpandData)} />
        </div>
        <div role="button" style={{ border: '1px solid white', borderRadius: '15%' }} className='d-flex align-items-center justify-content-center p-1' onClick={() => handleTicketExpandView(null)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="1.5vw" viewBox="0 0 512 512" style={{ fill: "#ffff" }}><path d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z" /></svg>
        </div>
      </div>
      {/* body content*/}

      <div className={cn("row overflowY col-12 mr-0 ml-0 px-1", styles.body)}>{renderGroups()}</div>;

      <div className={cn('d-flex justify-content-between align-items-center', styles.footer)}>
        <div role='button' className={styles.LeftArrow} style={{ backgroundColor: currentHistoryPage - 1 === 0 ? "gray" : '#6A4DAE' }} onClick={() => {
          if (currentHistoryPage > 1) {
            let page = currentHistoryPage - 1;
            setCurrentHistoryPage(page);
          }
        }}>

          <img
            src={LessThanIcon}
            alt="LessThanIcon"
            width="12px"
          />
          <span className={styles.Zero}>{currentHistoryPage - 1}</span>
        </div>
        <div role='button' className={cn('d-flex align-items-center justify-content-center p-0', styles.button)} style={{ backgroundColor: '#0060FF', color: 'white' }} onClick={() => { handleBumpItemClick() }} >
          {selectedObjects?.hasOwnProperty(ticketExpandData[0]?.checkPrep?.id + '') && selectedObjects[ticketExpandData[0]?.checkPrep?.id].length > 0 &&
            <img src={checkBoxIcon} alt="bump selected" width="20px" />}
          <span className='pl-1'>{LABEL().KDS_BUMP}</span>
        </div>
        <div role='button' className={cn(styles.LeftArrow, styles.rightArrow)}
          style={{ backgroundColor: totalHistoryPage - currentHistoryPage === 0 ? "gray" : '#6A4DAE' }}
          onClick={() => {
            if (currentHistoryPage < totalHistoryPage) {
              let page = currentHistoryPage + 1;
              setCurrentHistoryPage(page);
            }
          }}>
          <span className={styles.Zero}>{totalHistoryPage - currentHistoryPage}</span>

          <img
            src={greaterIcon}
            alt="greaterIcon"
            width="12px"
          />
        </div>
      </div>
    </div>
  )
}

export default TicketExpandModal;